// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"398":"d7f7fc63","429":"bd638a87","798":"bbe971e2"}[chunkId] + ".chunk.css";
};